module.exports = __webpack_public_path__ + "img/link_u2.4d239cd5.png";